export const chatApiPaths = {
  getStreamToken: '/chatservice/chats/token',
} as const;

export const getChatApiUrl = {
  getStreamToken: () => chatApiPaths.getStreamToken,
};
